<template>
<div v-if="status.requestInProgress">
	<v-dialog
	v-model="visible"
	width="300px"
	hide-overlay
	>
		<v-card
			color="primary"
			dark
		>
			<v-card-text>
			<template>
				In progress …
			</template>
			<v-progress-linear
				indeterminate
				color="white"
				class="mb-0"
			></v-progress-linear>
			</v-card-text>
		</v-card>

	</v-dialog>
</div>
<div v-else>
	<v-dialog v-model="visible" persistent width="800px">
		<v-card>
			<v-card-title class="headline">
				<div>
					Token details
					<small class="grey--text">{{token_id}}</small>
				</div>
			</v-card-title>
			<v-container>
				<v-form ref="token-edit" v-model="formValid">
				<v-layout row wrap>
					<v-flex xs12>
						<v-alert
						:value="status.error"
						type="error"
						icon="warning"
						>
						{{status.error}}
						</v-alert>
					</v-flex>
					<v-flex xs12>
						<v-text-field
							label="Name"
							placeholder="Enter a name"
							v-model="metadata.name"
							:rules="[...requiredRules, ...metadataRules]"
							required
						></v-text-field>
					</v-flex>
					<v-flex xs2>
						<v-text-field
						label="Colour"
						placeholder="Choose a colour"
						type="color"
						v-model="metadata.style.color">
						</v-text-field>
					</v-flex>
					<v-flex xs6 offset-xs4>
						<v-text-field
							label="Image URL"
							placeholder="https://…"
							v-model="metadata.imageUrl"
							:rules="metadataRules"
							required
						></v-text-field>
					</v-flex>
					<v-flex xs6>
						<v-textarea
							label="Description"
							placeholder="Enter an optional description"
							v-model="metadata.description"
							:rules="metadataRules"
						></v-textarea>
					</v-flex>
					<v-flex xs6>
						<v-img v-if="metadata.imageUrl"
						:src="metadata.imageUrl"
						contain
						height="150px"
						></v-img>
					</v-flex>
				</v-layout>
				</v-form>
			</v-container>
				<v-card-actions>
					<v-btn flat @click="dismiss">Cancel</v-btn>
					<v-spacer></v-spacer>
					<v-btn flat color="primary" @click="submit" :disabled="!formValid">
						{{ token_id ? "Update" : "Create" }}
					</v-btn>
				</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import Vuex from 'vuex'
import api from '../../assets/js/api-instance'

export default {
	name: "FollowTokenEdit",
	
	props: ["show"],

	data () {
		return {
			token_id: null,
			metadata: {
				name: null,
				description: null,
				style: {
					color: "#0000ff"
				}
			},
			formValid: false,
			requiredRules: [
				v=> v && v.length > 0 || "Please provide a name"
			],
			metadataRules: [
				v => JSON.stringify(this.metadata).length <= 500 || "Token data exceeds the permitted limit – please shorten the name or description"
			],
			status: {}
		};
	},
	
	watch: {
		show () {
			console.log("SHOW WATCH", this.show);
			if (this.show instanceof Object) {
				this.setData(this.show);
			} else if (typeof this.show == 'string') {
				const token = this.$store.state.tokenData.tokens.find(t => t.token_id == this.show);
				this.setData(token);
				if (!token) {
					console.warn("Token editor: received token ID but cannot find this token", this.show);
				}
			} else {
				this.setData({});
			}
		}
	},
	
	computed: {
		visible: {
			get () {
				return !!this.show;
			},
			set () {
				this.$emit('hide')
			}
		}
	},

	methods: {
		setData (obj) {
			this.token_id = obj.token_id;
			this.metadata = Object.assign({
				name: null,
				description: null,
				imageUrl: null,
				style: {
					color: "blue"
				}
			}, obj.metadata);
		},
		
		async dismiss () {
			this.setData({});
			this.$emit("hide");
		},

		async submit () {
			try {
				let res = this.token_id
					? await api.updateToken(this.token_id, {metadata: this.metadata})
					: await api.createToken({metadata: this.metadata});
				console.log("token", res);
				this.$store.dispatch('restore');
				await this.dismiss();
			} catch (err) {
				if (err.unauthorised) {
					this.status = { error: "Unauthorised" };
				} else if (err.code == "network_error") {
					this.status = { error: "Network error" };
				} else {
					this.status = { error: "Unknown error" };
				}
			}
		}
	}

}
</script>
